var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 122
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.6727,
    cy: 60.6727,
    r: 60.6727,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.6727,
    cy: 60.6727,
    r: 60.6727,
    fill: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.6727,
    y: -10.9211,
    width: 73.6162,
    height: 150.064,
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.83064,
    y: 4.93005,
    width: 72.6162,
    height: 120.345,
    transform: "rotate(-45 4.83064 4.93005)",
    fill: "#F0F2F8",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1727,
    y: -4.21246,
    width: 72.6319,
    height: 125.058,
    fill: "#F0F2F8",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.202,
    y: 61.1726,
    width: 72.6319,
    height: 126.825,
    transform: "rotate(90 123.202 61.1726)",
    fill: "#F0F2F8",
    stroke: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.887c11fd3dda8867232170afb27dc5ff.svg";
export { ForwardRef as ReactComponent };